<div class="datatable--gray-header">
  <p-table
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} delivery windows"
    [value]="deliveryWindows()"
    [columns]="columns()"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 25]"
    [loading]="loading()"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.sortable ? col.field : undefined">
            {{ col.header }}
            @if (col.sortable) {
              <p-sortIcon [field]="col.field"></p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingheader">
      <tr>
        @for (col of columns(); track col.field) {
          <th>
            <p-skeleton [width]="col.sortable ? '7rem' : '5rem'"></p-skeleton>
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-deliveryWindow>
      <tr class="delivery-window-rows" [attr.data-testid]="'delivery-window-row-' + deliveryWindow.deliveryWindowId">
        <td>{{ formatTime(deliveryWindow.startTime) }}</td>
        <td>{{ formatTime(deliveryWindow.endTime) }}</td>
        <td>{{ deliveryWindow.maxDeliveriesPerDay }}</td>
        <td>
          <div class="action-buttons-container">
            <p-button
              icon="pi pi-pencil"
              severity="secondary"
              size="small"
              data-testid="delivery-window-edit"
              pTooltip="Edit delivery window"
              [text]="true"
              (onClick)="onEditDeliveryWindow(deliveryWindow)"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              size="small"
              data-testid="delivery-window-delete"
              pTooltip="Delete delivery window"
              [text]="true"
              [loading]="deletingId() === deliveryWindow.deliveryWindowId"
              (onClick)="deleteDeliveryWindow(deliveryWindow)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="100%">
          <div class="empty-state">
            <div class="empty-content">
              <div class="empty-icon">
                <i class="pi pi-calendar-clock"></i>
              </div>
              <div class="empty-header">No delivery windows yet</div>
              <p class="empty-description">
                Create your first delivery window to start scheduling deliveries for this geofence.
              </p>
              <p-button
                data-testid="delivery-window-create"
                label="Create Delivery Window"
                icon="pi pi-plus"
                (onClick)="onCreateDeliveryWindow()"
              ></p-button>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loadingbody">
      <tr>
        <td><p-skeleton width="4rem"></p-skeleton></td>
        <td><p-skeleton width="4rem"></p-skeleton></td>
        <td><p-skeleton width="3rem"></p-skeleton></td>
        <td><p-skeleton width="5rem"></p-skeleton></td>
      </tr>
    </ng-template>
  </p-table>
</div>
<app-delivery-window-form-dialog
  [visible]="showFormDialog()"
  [mode]="dialogMode()"
  [value]="selectedDeliveryWindow()"
  [loading]="saving()"
  (formSubmit)="submitDeliveryWindowData($event)"
  (cancel)="cancelSubmission()"
  (visibleChange)="dialogVisibility($event)"
></app-delivery-window-form-dialog>
